<template>
	<div class="menu-mobile-container d-lg-none">
		<div class="row nav-movil overflow-auto no-gutters" id="menu-container">
			<!--<div class="col-12 overflow-auto px-0">-->
			<ul class="list-group list-group-horizontal px-2 w-100 d-flex align-items-center">
				<li @click="desplazar($event,'inicio',0)" class="list-group-item">
					<router-link to="/clientes/">
						<i :class="{ active: current == 'inicio'}" class="icon-grupo-4302"></i>
					</router-link>
				</li>
				<!-- <li @click="desplazar($event,'captura-pedido',1)" class="list-group-item" id="captura-pedido">
					<router-link to="/clientes/captura-pedidos/mi-lista-de-pedido">
						<i :class="{ active: current == 'captura-pedido'}" class="icon-grupo-4303"></i>
					</router-link>
				</li> -->
				<li  class="list-group-item" id="captura-pedido">
					<router-link to="" @click.native="desplazar($event,'captura-pedidos',1)" >
						<i :class="{ active: current == 'captura-pedidos'}" class="icon-grupo-4303"></i>
					</router-link>
				</li>
				<li @click="desplazar($event,'estatus-pedido',2)" class="list-group-item" id="estatus-pedido">
					<router-link to="/clientes/estatus-de-pedido">
						<i :class="{ active: current == 'estatus-pedido'}" class="icon-grupo-4304"></i>
					</router-link>
				</li>
				<li @click="desplazar($event,'adeudos',3)" class="list-group-item" id="adeudos">
					<router-link to="/clientes/adeudos">
						<i :class="{ active: current == 'adeudos'}" class="icon-grupo-4305"></i>
					</router-link>
				</li>
				<li @click="desplazar($event,'factura',4)" class="list-group-item" id="factura">
					<router-link to="/clientes/facturas">
						<i :class="{ active: current == 'factura'}" class="icon-grupo-4306"></i>
					</router-link>
				</li>
				<li @click="desplazar($event,'carrito',5)" class="list-group-item" id="carrito">
					<router-link to="/clientes/carrito">
						<i :class="{ active: current == 'carrito'}" class="icon-grupo-4307">
							<span class="point-yellow"></span>
						</i>
					</router-link>
				</li>
				<li @click="desplazar($event,'pagar',6)" class="list-group-item" id="pagar">
					<router-link to="/clientes/pagar">
						<i :class="{ active: current == 'pagar'}" class="icon-grupo-4308">
							<span class="point-red"></span>
						</i>
					</router-link>
				</li>
				<li @click="desplazar($event,'referenciarpagos',14)" class="list-group-item" id="referenciarpagos"  v-if="permitirReferenciar">
					<router-link to="/clientes/referenciarpagos">
						<i :class="{ active: current == 'referenciarpagos'}" 
							class="fa fa-credit-card"></i>
					</router-link>
				</li>
				<!-- se oculta en el mobile, hasta que tengamos un diseño
				<li
					:class="{ active: current == 'estadisticas'}"
					@click="desplazar($event,'estadisticas',7)"
					class="list-group-item"
					id="estadisticas"
				>
					<router-link to="">
						<i class="icon-grupo-4309"></i>
					</router-link>
				</li>-->
				<li
					:class="{ active: current == 'ayuda'}"
					@click="desplazar($event,'ayuda',8)"
					class="list-group-item"
					id
				>
					<router-link to="/clientes/ayuda/0">
						<i :class="{ active: current == 'ayuda'}" class="icon-grupo-4310"></i>
					</router-link>
				</li>
				<li v-if="usuarioGlobal().user == 15893"
					:class="{ active: current == 'herramientas'}"
					@click="desplazar($event,'herramientas',8)"
					class="list-group-item"
					id
				>
					<router-link to="/clientes/herramientas">
						<i :class="{ active: current == 'herramientas'}" class="fas fa-cogs"></i>
					</router-link>
				</li>
				
			</ul>
		</div>
		<!--</div>-->
		<b-collapse id="collapse-1" v-if="visibleCollapse" v-click-outside="onClickOutside" class="collapse-style" v-model="visibleCollapse">
			<div class="col m-0" >
				<ul class="list-group list-group-vertical" >
					<li class="list-group-item" :class="{ active: currentSubMenu == 'mi-lista-de-pedido'}">
						<router-link class="routerLink" @click.native="desplazar($event,'mi-lista-de-pedido',1)" to="/clientes/captura-pedidos/mi-lista-de-pedido" > 
						<div class="w-100 m-0"> Mi lista de pedido</div></router-link>
					</li>
					<li class="list-group-item" :class="{ active: currentSubMenu == 'busqueda-general'}" >
						<router-link class="routerLink" @click.native="desplazar($event,'busqueda-general',9)" to="/clientes/captura-pedidos/busqueda-general?buscar=&orden=0&codClasificacion=0&codFormaFarmaceutica=0&tipoFormula=A&codFormula=0&contenidoVenta=0&pagina=1&busquedaAvanzada=false"><div class="w-100 m-0">Catálogo general</div></router-link>
					</li>
					<li class="list-group-item" :class="{ active: currentSubMenu == 'nuevos'}">
						<router-link class="routerLink" to="/clientes/captura-pedidos/nuevos"  @click.native="desplazar($event,'nuevos',10)"><div class="w-100 m-0">Nuevos</div></router-link>
					</li>
					<li class="list-group-item" :class="{ active: currentSubMenu == 'ofertas'}">
						<router-link class="routerLink"  @click.native="desplazar($event,'ofertas',11)" to="/clientes/captura-pedidos/ofertas" ><div class="w-100 m-0">Ofertas</div></router-link>
					</li>
					<li class="list-group-item" :class="{ active: currentSubMenu == 'remates'}">
						<router-link class="routerLink" @click.native="desplazar($event,'remates',12)" to="/clientes/captura-pedidos/remates" ><div class="w-100 m-0">Remates</div></router-link>
					</li>
					<li v-if="esBuenFin" class="list-group-item" :class="{ active: currentSubMenu == 'buenFin'}">
						<router-link class="routerLink" @click.native="desplazar($event,'buenFin',12)" to="/clientes/captura-pedidos/buen-fin" ><div class="w-100 m-0">Buen Fin</div></router-link>
					</li>
					<li class="list-group-item" :class="{ active: currentSubMenu == 'cambios-de-precio'}">
						<router-link class="routerLink"  @click.native="desplazar($event,'cambios-de-precio',13)" to="/clientes/captura-pedidos/cambio-de-precio" ><div class="w-100 m-0">Cambios de precio</div></router-link>
					</li>
				</ul>
			</div>
		</b-collapse>

	</div>
</template>

<script>
	import vClickOutside from 'v-click-outside'
	import { mapActions, mapState } from 'vuex'
	export default {
		name: "MenuMovil",
		props: ["msg", "inicioClientes", "busquedaGeneral", "esBuenFin"],
		data() {
			return {
				current: "inicio",
				currentSubMenu:"",
				parametros: {
					buscar: "",
					orden: 0,
					codClasificacion: 0,
					codFormaFarmaceutica: 0,
					tipoFormula: "",
					codFormula: 0,
					contenidoVenta: 0,
					pagina: 1
				},
				visibleCollapse: false,
			}
		},
		created(){
			
		},
		mounted() {
			this.obeterAccesoReferenciar()
			if (this.$route.path.includes("mi-lista-de-pedido")) {
				this.currentSubMenu = 'mi-lista-de-pedido'
				this.desplazar(event,'captura-pedidos',1)
			} else if (this.$route.path.includes("busqueda-general")) {
				this.currentSubMenu = 'busqueda-general'
				this.desplazar(event,'busqueda-general',9)
			} else if (this.$route.path.includes("nuevos")) {
				this.currentSubMenu = 'nuevos'
				this.desplazar(event, "nuevos", 10)
			} else if (this.$route.path.includes("ofertas")) {
				this.currentSubMenu = 'ofertas'
				this.desplazar(event, "ofertas", 11)
			} else if (this.$route.path.includes("remates")) {
				this.currentSubMenu = 'remates'
				this.desplazar(event, "remates", 12)
			} else if (this.$route.path.includes("buenFin")) {
				this.currentSubMenu = 'buenFin'
				this.desplazar(event, "buenFin", 12)
			}else if (this.$route.path.includes("cambio-de-precio")) {
				this.currentSubMenu = 'cambios-de-precio'
				this.desplazar(event, "cambios-de-precio", 13)
			}else if (this.$route.path.includes("estatus-de-pedido")) {
				//console.log('estatus', '')
				this.desplazar(event, "estatus-pedido", 2)
			} else if (this.$route.path.includes("adeudos")) {
				//console.log('adeudos', '')
				this.desplazar(event, "adeudos", 3)
			} else if (this.$route.path.includes("facturas")) {
				//console.log('factura', '')
				this.desplazar(event, "factura", 4)
			} else if (this.$route.path.includes("carrito")) {
				//console.log('carrito', '')
				this.desplazar(event, "carrito", 5)
			} else if (this.$route.path.includes("pagar")) {
				//console.log('pagar', '')
				this.desplazar(event, "pagar", 6)
			} else if (this.$route.path.includes("ayuda")) {
				//console.log('ayuda', '')
				this.desplazar(event, "ayuda", 8)
			} else if (this.$route.path.includes("herramientas")){
				this.desplazar(event, "herramientas", 14)
			}
			else if (this.$route.path.includes("referenciarpagos") && !this.soloConsulta){
				this.desplazar(event, "referenciarpagos", 14)
			}
			//console.log(this.$route.path)
		},
		directives: {
			clickOutside: vClickOutside.directive
		},
		methods: {
			...mapActions(['obeterAccesoReferenciar']),
			onClickOutside () {
				//console.log('click fuera', '')
				this.visibleCollapse = false
			},
			inicioCatalogoGeneral() {
				//this.buscar()
			},
			buscar() {
				this.$emit("buscar", this.parametros)
			},
			desplazar(e, opcion, num) {
				if(num == 1 || num == 9 || num == 10 || num == 11 || num == 12 || num == 13){ //son las opciones del submenu, las separe por que fue la unica manera en que se me ocurrio xD sorry!!
					
					console.log(this.current)

					this.current = 'captura-pedidos'
					
					console.log(opcion)
					console.log(num)
					if(opcion == "captura-pedido-busqueda"){	
						this.visibleCollapse = false
					} else {
						this.visibleCollapse = !this.visibleCollapse
					}
					

					if(opcion == 'captura-pedidos' && this.currentSubMenu == ''){ //si le da al icono y no tiene uno del submenu seleccionado se selecciona mi lista de pedido por default
						this.$router.push({ path: `/clientes/captura-pedidos/mi-lista-de-pedido` })
					}
					else if(opcion == 'captura-pedidos'){//es para cuando le dan al icono que se muestre u oculte el collapse... si ya tiene uno seleccionado
						return
					}

					if(this.currentSubMenu.trim().length <= 0){//para que se seleccione el primero si no esta ninguno seleccionado
						this.currentSubMenu = 'mi-lista-de-pedido'
					}
					else{
						this.currentSubMenu = opcion //se agrega el seleccionado del submenu
					}
				}
				else{
					
					this.current = opcion
					this.currentSubMenu = ''
					this.visibleCollapse = false
				}

				var menuContainer = document.getElementById("menu-container")
				//var element = document.getElementById(opcion);

				var resolucion = menuContainer.clientWidth
				var salto = 0
				if (e != undefined) {
					if (resolucion < 576) {
						if (e.clientX <= resolucion / 2) {
							salto = num > 3 ? 80 / num : 0
						} else {
							salto = 80 * num
						}
					} else {
						if (e.clientX <= resolucion / 2) {
							salto = 0
						} else {
							salto = 80 * num
						}
					}
				}

				if (num == 1) {
					this.inicioCatalogoGeneral()
				}

				// console.log(
				// 	num,
				// 	"resolucion:" + resolucion,
				// 	"mitas: " + resolucion / 2,
				// 	"ClientX: " + e.clientX,
				// 	"ScreenX: " + e.screenX,
				// 	"salto: " + salto
				// )

				menuContainer.scrollTo({
					left: salto,
					behavior: "smooth",
				})
			},
		},
		watch: {
			busquedaGeneral(newValue) {
				if (newValue) {
					this.desplazar(event, "captura-pedido-busqueda", 1)
				}
			},
			inicioClientes(newValue) {
				if (newValue) {
					this.desplazar(event, "inicio", 0)
				}
			},
		},
		computed:{
			...mapState(['permitirReferenciar'])
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.menu-mobile-container{
		position: relative;
	}

	.collapse-style {
		position: absolute;
		/* padding-top: 0.6rem;		 */
		z-index: 101; 		
		background-color: var(--bg-menu-blue);
		width: 320px;
	}
	
	.routerLink{
		color: white;
		width: 100%;
	}
	.collapse-style ul li{
		background-color: var(--bg-menu-blue);
		padding-top: 0.3rem;
		font-size: 15px !important;
		vertical-align: middle !important;
		border: none;
		text-align: left !important;
		color: white !important;
	}

	.collapse-style ul li.active {
		background-color: var(--color-font-icon) !important;
		border-radius: 2%; 
		transition: all 0.5s;
		color: white !important;
	} 

	.w-auto {
		/* width: auto;
		text-align: left !important;
		color: white !important; */

	}
	.list-group-item {
		flex: 1 1 0px;
		text-align: center;
	}
	.nav-movil{
		background-color: var(--bg-menu-blue);
		min-height: 85px;
		padding-top: 0.6rem;		
		overflow-y: hidden !important;
	}

	.nav-movil ul li i {
		font-size: 31px;
		color: var(--color-font-icon);
		background-color: var(--bg-menu-blue);
		padding: 10px;
	}

	.nav-movil ul li {
		background-color: var(--bg-menu-blue);
		border: none;
		height: 62px;
		width: 62px;
		background-color: var(--bg-menu-blue);
		padding: 0.45rem 0.55rem;
		/*margin-right: 1.3rem;*/
	}

	.nav-movil ul li i.active {
		background-color: var(--color-font-icon) !important;
		border-radius: 50%;
		transition: all 0.5s;
	}

	.nav-movil ul li i.active {
		color: white !important;
		background-color: var(--color-font-icon) !important;
		transition: all 0.5s;
	}

	.point-red {
		top: 0.1rem;
		left: 2.5rem;
		position: absolute;
		width: 0.8rem;
		height: 0.8rem;
		border-radius: 50%;
		background: #e12828;
	}

	.point-yellow {
		top: 0.45rem;
		left: 2.5rem;
		position: absolute;
		width: 0.8rem;
		height: 0.8rem;
		border-radius: 50%;
		background: var(--bg-yellow);
	}

	@media (max-width: 640px) {
		.nav-movil ul li i {
			padding: 3px !important;
		}
	}

	@media (max-width: 360px) {
		.nav-movil {
			background-color: var(--bg-menu-blue) !important;
			min-height: 64px;
			padding: 0px;
		}

		.nav-movil ul li i {
			font-size: 23px;
			padding: 3px !important;
		}

		.nav-movil ul li,
		.nav-movil ul li.active {
			height: 48px;
			width: 48px;
			padding: 0.3rem 0.5rem;
			margin-right: 0.9rem;
			margin-top: 0.5rem;
		}

		.point-red {
			top: -0.1rem;
			left: 2rem;
			position: absolute;
			width: 0.7rem;
			height: 0.7rem;
			border-radius: 50%;
			background: #e12828;
		}

		.point-yellow {
			top: 0.1rem;
			left: 1.9rem;
			position: absolute;
			width: 0.7rem;
			height: 0.75rem;
			border-radius: 50%;
			background: var(--bg-yellow);
		}
	}
</style>
